import type { BaseDialogProps } from '@/shared/ui/DialogKit';
import { BaseDialog } from '@/shared/ui/DialogKit';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';

type Props = BaseDialogProps & {
  message?: string;
  suggestedCompanyName?: string;
  onGoBack: () => void;
  onSwitch?: () => void;
};

const SwitchCompanyDialog = ({ message, suggestedCompanyName, onGoBack, onSwitch, title, ...props }: Props) => {
  return (
    <BaseDialog {...props} title={title} fullWidth maxWidth="sm">
      <DialogContent>
        <Typography>
          {message ||
            `You need to sign out of current pharmacy and sign in to ${
              suggestedCompanyName || 'another pharmacy'
            } to view this patient's details. Do you wish to continue?`}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onGoBack} color="primary" variant="outlined">
          Go Back
        </Button>
        {onSwitch && (
          <Button onClick={onSwitch} color="primary" variant="contained">
            Switch Pharmacy
          </Button>
        )}
      </DialogActions>
    </BaseDialog>
  );
};

export default SwitchCompanyDialog;
